import { render, staticRenderFns } from "./PreviewCostProcess.vue?vue&type=template&id=966d6e48&"
import script from "./PreviewCostProcess.vue?vue&type=script&lang=js&"
export * from "./PreviewCostProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports